import { useQuery } from '@apollo/client';
import type {
  UseLalSegmentsListFetch,
  UseLalSegmentsListFetchProps,
} from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import type { FetchMore } from '@openx/components-segment/types';
import type { QueryVar } from '@openx/types/serverSideCriteria';
import { useCallback } from 'react';
import {
  GetLalSegmentFeedDocument,
  type GetLalSegmentFeedQuery,
  type GetLalSegmentFeedQueryVariables,
} from '../../../graphql/query/segments/lal/GetLalSegmentFeed.generated';
import { GetLalSegmentsListDocument } from '../../../graphql/query/segments/lal/GetLalSegmentsList.generated';

type QueryParams = GetLalSegmentFeedQueryVariables & QueryVar;

export const useLalSegmentsListFetch: UseLalSegmentsListFetch = ({
  variables,
  options,
  usePrefetch,
}: UseLalSegmentsListFetchProps<QueryParams>) => {
  const { client, data, error, loading } = useQuery(GetLalSegmentsListDocument, {
    onCompleted: ({ lookalike_definition_aggregate }) =>
      options?.onCompleted?.(lookalike_definition_aggregate.aggregate?.count),
    variables,
  });

  const { lalSegmentFeed = [] } = data ?? {};

  const fetchMore: FetchMore<QueryParams> = useCallback(
    queryOptions => {
      client.query<GetLalSegmentFeedQuery, GetLalSegmentFeedQueryVariables>({
        fetchPolicy: 'network-only',
        query: GetLalSegmentFeedDocument,
        variables: { ...variables, ...queryOptions.variables },
      });
    },
    [variables, client]
  );

  usePrefetch?.(fetchMore);

  return {
    error,
    loading,
    lalSegments: lalSegmentFeed,
  };
};
